export const __DEV__ = process.env.NODE_ENV !== 'production';
export const activeClassName = 'vui-active';
export const activeItemShade = 30;
export const dimmedBorderColor = 'grey.40';
